define('ShippingByLocation', [
  'underscore',
  'jQuery',
  'SCModel',
  'ZipCodeSession',
  'ShippingByLocation.Repository',
  'ShippingByLocation.Collection'
], function ShippingByLocationModule(
  _,
  jQuery,
  SCModelComponent,
  ZipCodeSession,
  ShippingByLocationRepository,
  ShippingByLocationCollection
) {
  'use strict';

  var SCModel = SCModelComponent.SCModel;

  function ShippingByLocation(attributes, options) {
    SCModel.call(this, attributes, options);

    this.isLoadingFlag = true;
    /** @type {ComponentContainer} */
    this.container = attributes.container;
    /** @type {ItemInfo} */
    this.itemInfo = null;
    /** @type {UserProfileData} */
    this.profile = null;
    /**  @type {SCCollection} */
    this.locations = new ShippingByLocationCollection();
  }

  ShippingByLocation.prototype = Object.create(SCModel.prototype);

  ShippingByLocation.mountToApp = function mountToApp(container) {
    var pdp = container.getComponent('PDP');
    pdp.on('beforeShowContent', function beforeShowContent() {
      ShippingByLocationRepository.setupForCurrentProduct(container, ShippingByLocation);
    });
  };

  ShippingByLocation.forCurrentProduct = function forCurrentProduct(container) {
    return ShippingByLocationRepository.getForCurrentProduct(container, ShippingByLocation);
  };

  _.extend(ShippingByLocation.prototype, {
    constructor: ShippingByLocation,

    getItemInfo: function getItemInfo() {
      return this.itemInfo;
    },

    getProfile: function getProfile() {
      return this.profile;
    },

    getLocations: function getLocations() {
      return this.locations;
    },

    /**
     * @param {number} zipCode
     * @param {object} [options]
     * @param {boolean} [options.save]
     * @returns {jQuery.Promise}
     */
    setZipCode: function setZipCode(zipCode, options) {
      var deferred = jQuery.Deferred();
      this.getLocations().setZipCode(zipCode);
      if (options && options.save) {
        ZipCodeSession.setZipCode(zipCode)
          .done(function done() {
            deferred.resolve();
          })
          .fail(function fail(error) {
            deferred.reject(error);
          });
      } else {
        deferred.resolve();
      }
      return deferred.promise();
    },

    getZipCode: function getZipCode() {
      return this.getLocations().getZipCode();
    },

    setLocationIds: function setLocationIds(locationIds) {
      this.getLocations().setLocationIds(locationIds);
    },

    getLocationIds: function getLocationIds() {
      return this.getLocations().getLocationIds();
    },

    setSubsidiaries: function setSubsidiaries(subsidiaries) {
      return this.getLocations().setSubsidiaries(subsidiaries);
    },

    isLoading: function isLoading() {
      return this.isLoadingFlag;
    },

    isLoggedIn: function isLoggedIn() {
      return this.profile.isloggedin;
    },

    shouldShow: function shouldShow() {
      return !this.isLoading() && this.isLoggedIn() && this.getLocationIds().length > 0;
    },

    getDefaultZipCode: function getDefaultZipCode() {
      var profile = this.getProfile();
      var defaultAddress;

      if (!profile || !profile.addressbook || profile.addressbook.length === 0) {
        return null;
      }
      defaultAddress = _.findWhere(profile.addressbook, { defaultshipping: 'T' });
      if (!defaultAddress) {
        return null;
      }
      return parseInt(defaultAddress.zip, 10) || null;
    },

    getQuantityAvailableForLocations: function getQuantityAvailableForLocations() {
      var itemInfo = this.getItemInfo();
      var details = itemInfo.item.quantityavailable_detail;
      var availableLocationIds = this.getLocations().map(function map(location) {
        return location.get('id');
      });
      var itemLocations;

      if (!details) {
        return [];
      }
      itemLocations = details.locations;
      /* Filter item locations by locations found by service. */
      if (availableLocationIds && availableLocationIds.length) {
        itemLocations = _.filter(itemLocations, function (location) {
          return _.contains(availableLocationIds, location.internalid);
        });
      }
      return itemLocations || [];
    },

    setup: function setup() {
      if (!this.deferred) {
        this.executeSetup();
      }
      return this.deferred.promise();
    },

    executeSetup: function executeSetup() {
      var self = this;
      /** @type {PDP} */
      var pdp = this.container.getComponent('PDP');
      /** @type {UserProfile} */
      var userProfile = this.container.getComponent('UserProfile');
      /** @type {Environment} */
      var environment = this.container.getComponent('Environment');

      var subsidiaries = environment.getConfig('siteSettings').subsidiaries || [];
      var subsidiaryIds = _.map(subsidiaries, function map(subsidiary) {
        return subsidiary.internalid;
      });

      self.setSubsidiaries(subsidiaryIds);

      this.deferred = jQuery.Deferred();
      this.itemInfo = pdp.getItemInfo();
      jQuery
        .when(ZipCodeSession.getZipCode(), userProfile.getUserProfile())
        .done(function doneWhen(zipCode, profile) {
          self.profile = profile;

          self.setZipCode(zipCode || self.getDefaultZipCode());
          self.setLocationIds(
            _.map(
              self.getQuantityAvailableForLocations(),
              function mapQuantities(quantityAvailable) {
                return quantityAvailable.internalid;
              }
            )
          );

          self.locations
            .update()
            .done(function fetchDone() {
              self.isLoadingFlag = false;
              self.deferred.resolve(self);
            })
            .fail(function fetchFail(error) {
              console.error('ShippingByLocation.setup() failed loading locations', error);
              self.isLoadingFlag = false;
              self.deferred.reject(error);
            });
        })
        .fail(function profileFail(error) {
          console.error('ShippingByLocation.setup() failed', error);
          self.isLoadingFlag = false;
          self.deferred.reject(error);
        });
    },

    update: function update() {
      return this.getLocations().update();
    }
  });

  return ShippingByLocation;
});
